import { DateRange, RelativeValue, RelativeUnit } from '@logz-pkg/utils';
import { RELATIVE_TIME_UNIT_MAP, UNIT_TO_RELATIVE_MAP, RELATIVE_TIME_REGEX } from './constants';

export type ParsedRelativeInput = {
  value: number | '';
  unit: string;
};

export const parseRelativeTimeToManualInput = (relativeTime: RelativeValue): ParsedRelativeInput | null => {
  const timeStr = relativeTime.replace('now-', '');
  const match = timeStr.match(RELATIVE_TIME_REGEX);

  if (match) {
    const [, value, unit] = match;

    return { value: parseInt(value, 10), unit: RELATIVE_TIME_UNIT_MAP[unit] ?? 'minutes' };
  }

  return null;
};

export const createDateRangeFromManualInput = (input: ParsedRelativeInput): DateRange => {
  const { value, unit } = input;

  if (value === '' || value <= 0) {
    return {
      start: { type: 'relative', value: 'now-0m' as RelativeValue },
      end: { type: 'relative', value: 'now' as RelativeValue },
    };
  }

  const relativeValue = `now-${value}${UNIT_TO_RELATIVE_MAP[unit] ?? 'm'}` as RelativeValue;

  return {
    start: { type: 'relative', value: relativeValue },
    end: { type: 'relative', value: 'now' as RelativeValue },
  };
};

export const isValidRelativeUnit = (unit: string): unit is RelativeUnit => {
  return Object.keys(RELATIVE_TIME_UNIT_MAP).includes(unit);
};
